import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { MapPin, Phone, Mail, Terminal, CheckCircle, ExternalLink, Award, Users } from 'lucide-react';
import { Button } from '../components/ui/button';

const IndoreHubPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const seoTitle = "Best Cybersecurity & Ethical Hacking Institute in Indore | Ciqura Labs";
  const seoDescription = "Join Ciqura Labs at Shagun Arcade, Vijay Nagar, Indore. Premium hands-on training labs in Cybersecurity, AIML, and Cloud with verified corporate internships at Ciqur24 Bengaluru.";
  const canonicalUrl = "https://ciquralabs.ciqur24.com/indore";
  const registrationLink = "https://forms.office.com/Pages/ResponsePage.aspx?id=GIlUwqulxkW2gUlR5VePC12nZ4fz5yRFkrQsWYzu1nBUN01NTlFFS0lQOFhRNjk4MDVaQloxTkJBRS4u";

  return (
    <div style={{ background: 'var(--bg-primary)', minHeight: '100vh', paddingTop: '80px', color: 'var(--text-primary)', display: 'flex', flexDirection: 'column' }}>
      <Helmet>
        <title>{seoTitle}</title>
        <meta name="description" content={seoDescription} />
        <link rel="canonical" href={canonicalUrl} />
      </Helmet>

      <main style={{ flex: '1 0 auto', padding: '80px 7.6923%' }}>
        <h1 className="display-huge" style={{ textAlign: 'center', marginBottom: '40px' }}>
          Indore Center for <span style={{ color: 'var(--brand-primary)' }}>Cybersecurity & AI</span>
        </h1>
        <p className="body-large" style={{ color: 'var(--text-secondary)', textAlign: 'center', maxWidth: '800px', margin: '0 auto 60px' }}>
          Located at Shagun Arcade, Vijay Nagar, we bridge the gap between academic theory and enterprise-level operations.
        </p>
        
        {/* Basic Content Placeholder */}
        <div style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'center' }}>
          <Button className="btn-primary" onClick={() => window.open(registrationLink, '_blank')}>
            Register for Indore Batch <ExternalLink size={18} style={{ marginLeft: '8px' }} />
          </Button>
        </div>
      </main>
    </div>
  );
};

export default IndoreHubPage;